import uuidv4 from '../utils/guid'

if (
  window.location.pathname.includes('/business-finance/journey') &&
  window.__APP_ENV__ === 'staging'
) {
  const randomId = uuidv4()
  document.cookie = `usci=${randomId}; path=/`
}
